module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-satpolpp",
  subdomain: "satpolpp",
};
